import { render } from "./ProductDetailsView.vue?vue&type=template&id=3cbbc536&scoped=true"
import script from "./ProductDetailsView.vue?vue&type=script&lang=js"
export * from "./ProductDetailsView.vue?vue&type=script&lang=js"

import "./ProductDetailsView.vue?vue&type=style&index=0&id=3cbbc536&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3cbbc536"

export default script